import { mapMutations } from "vuex";
import {
    CHANGE_POPUP_LDAP,
    SHOW_POPUP_AUTH_LDAP_WARNING
} from '@/store/mutation-types';

export default {
    name: 'ldap-btn',
    props: ['title'],
    methods: {
        ...mapMutations({
            changePopupLdap: `auth/${CHANGE_POPUP_LDAP}`,
            changePopupLdapWarning: `auth/${SHOW_POPUP_AUTH_LDAP_WARNING}`,
        }),
        changePopup(status){
            if(localStorage.getItem('showLdapWarning') === '0'){
                localStorage.setItem('showLdapWarning', '1');
                this.changePopupLdapWarning(true);
            }else{
                this.changePopupLdap(status);
            }
        },
    },
    destroyed(){

    }
}
